import styles from "./Spinner.module.css";

interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <div
      className={`${styles.spinner} ${styles[size]}${className ? ` ${className}` : ''}`}
      role="status"
      aria-label="Loading"
    />
  );
}
